<template>
  <RevToast
    :close-alternative-text="i18n(toastTranslations.closeToast)"
    :duration="10000"
    name="quotes-timeout-info-toast"
    :opened="isToastOpen"
    :title="i18n(translations.toastTimeoutTitle)"
    to="#toast-wrapper"
    variant="neutral"
    @close="isToastOpen = false"
  >
    {{ i18n(translations.toastTimeoutContent) }}
  </RevToast>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import toastTranslations from '@backmarket/nuxt-module-toast/translations'
import { RevToast } from '@ds/components/Toast'

import translations from './QuotesTimeoutToast.translations'

const isToastOpen = defineModel<boolean>({ default: false })
const i18n = useI18n()
</script>
